var React = require('react');

function IconPhoneCall (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.346.865 13.69.021a.85.85 0 0 0-.967.49l-1.687 3.937a.842.842 0 0 0 .242.984l2.13 1.744a13.03 13.03 0 0 1-6.229 6.23l-1.744-2.131a.843.843 0 0 0-.984-.243L.514 12.72a.854.854 0 0 0-.493.97l.844 3.656c.088.38.426.654.823.654C10.69 18 18 10.705 18 1.688a.843.843 0 0 0-.654-.823Z"}));
}

IconPhoneCall.defaultProps = {"fill":"currentColor","viewBox":"0 0 18 18"};

module.exports = IconPhoneCall;

IconPhoneCall.default = IconPhoneCall;
